import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFoliumComponent } from './simple-icons-folium.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFoliumComponent ],
    exports:      [ SimpleIconsFoliumComponent ],
    bootstrap:    []
})
export class SimpleIconsFoliumModule {}
